<!-- dynamic menu -->
<header class="cv-header border-bottom">
    <nav class="navbar p-0 sticky bg-white">
        <div class="container-fluid">
            <div class="cus-menu-collapse menu">
                <a class="navbar-brand p-0" href="">
                    <img src="assets/logo.svg" alt="brand-logo" class="brand-logo" width="215">
                </a>
                <a href="javascript:void(0);" class="ic menu" tabindex="1">
                    <span class="line"></span>
                    <span class="line"></span>
                    <span class="line"></span>
                </a>
                <a href="javascript:void(0);" class="ic close"></a>
                <ul class="main-nav">
                    <li class="top-level-link mr-lg-2"><a routerLink="/how-it-works"><span translate>How it works</span></a></li>
                    <li class="top-level-link mr-lg-2">
                        <a class="mega-menu" routerLinkActive="active"><span translate>Categories</span></a>
                        <div class="sub-menu-block pb-3">
                            <div class="row m-0">
                                <div class="sub-menu-item">
                                    <h2 class="sub-menu-head" translate>Industries</h2>
                                    <ul class="sub-menu-lists">
                                        <li>
                                            <a routerLink="/healthcare" routerLinkActive="active" translate><i class="fa  fa-angle-right mr-1"></i>Healthcare</a>
                                        </li>
                                        <!-- <li *ngFor="let lists of categorylist" [value]="lists.id">{{lists.category_name}}</li> -->
                                        <li>
                                            <a routerLink="/education" routerLinkActive="active" translate><i class="fa  fa-angle-right mr-1"></i>Education</a>
                                        </li>
                                        <li>
                                            <a routerLink="/it-ites" routerLinkActive="active" translate><i class="fa  fa-angle-right mr-1"></i>IT & ITES</a>
                                        </li>
                                        <li>
                                            <a routerLink="/hotel-restaurants" routerLinkActive="active" translate><i class="fa  fa-angle-right mr-1"></i>Hotel & Restaurants</a>
                                        </li>
                                        <li>
                                            <a routerLink="/event-entertainment" routerLinkActive="active" translate><i class="fa  fa-angle-right mr-1"></i>Event & Entertainment</a>
                                        </li>
                                        <li>
                                            <a routerLink="/retail-manufacturing" routerLinkActive="active" translate><i class="fa  fa-angle-right mr-1"></i>Retail and Manufacturing</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="sub-menu-item">
                                    <h2 class="sub-menu-head" translate>Solutions</h2>
                                    <ul class="sub-menu-lists">
                                        <li>
                                            <a routerLink="/customer-experience" routerLinkActive="active">
                                                <span class="d-block" translate><i class="fa  fa-angle-right mr-1"></i>Customer Experience</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a routerLink="/field-survey-and-market-research" routerLinkActive="active">
                                                <span class="d-block" translate><i class="fa  fa-angle-right mr-1"></i>Field Survey & Market Research </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a routerLink="/employee-experience" routerLinkActive="active">
                                                <span class="d-block" translate><i class="fa  fa-angle-right mr-1"></i>Employee Experience</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a routerLink="/nps-survey" routerLinkActive="active">
                                                <span class="d-block" translate><i class="fa  fa-angle-right mr-1"></i>NPS<sup>&reg;</sup> Survey</span>
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                            <hr class="d-none">
                            <div class="row d-none">
                                <div class="col-lg-12 text-right">
                                    <a class="btn-link" routerLink="#">
                                        See all Categories
                                        <img src="../../../assets/arrow-right-green.svg" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="top-level-link mr-lg-2 "><a routerLink="/features" routerLinkActive="active"><span translate>Features</span></a></li>
                    <li class="top-level-link mr-lg-2 "><a routerLink="/templates" routerLinkActive="active"><span translate > Templates</span></a></li>
                    <li class="top-level-link mr-lg-3 "><a routerLink="/pricing" routerLinkActive="active"><span translate >Pricing</span></a></li>
                    <li class="top-level-link mr-lg-2 "><a href="https://beta.cviewsurvey.com/login" target="_blank" translate>Login</a></li>
                    <li><a class="btn-upgrade" href="https://beta.cviewsurvey.com/signup" target="_blank" translate (click)="tryNowPlan()">Try it free</a></li>
                </ul>
                <div class="d-none">
                    <div class="dropdown language d-inline-block">
                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          LN
                        </button>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">
                            <button class="dropdown-item" (click)="switchLanguage('en')">
                                <img src="assets/flags/us.svg" alt="">
                                <span>ENG</span>
                            </button>
                            <!-- <button class="dropdown-item" (click)="switchLanguage('ke')">KN</button>
                            <button class="dropdown-item" (click)="switchLanguage('hi')">HN</button> -->
                            <!-- </div>
                    </div> -->
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </nav>
</header>

<div class="mobile-login d-none">
    <div class=" ">
        <button class="btn text-uppercase btn-outline-secondary mr-lg-2 ">Login</button>
        <button class="btn text-uppercase btn-success ml-2">Try it free</button>
    </div>
</div>



<button (click)='topFunction()' id="myBtn" title="Go to top">
    <img src="assets/top_green.svg" alt="Got Top">
</button>